import React from "react";
import { useSelector } from "react-redux";
import Grid from "@ls/react-grid";
import {
  selectFetchingEntities,
  selectSelectedEntities,
} from "state/selections/selectors";
import SelectionState from "state/selections/SelectionState";
import styled from "styled-components";
import DeleteCellRenderer from "./DeleteCellRenderer";
import LoadingMask from "@ls/react-loading-mask";
const columnDefs = [
  {
    width: 50,
    resizable: false,
    draggable: false,
    sortable: false,
    cellRenderer: "DeleteCellRenderer",
    cellStyle: {
      border: "none",
    },
  },
  {
    headerName: "Entity ID",
    field: "entityId",
    width: 75,
  },
  {
    headerName: "Entity",
    field: "label",
    width: 470,
  },
  {
    headerName: "Type",
    field: "type",
    width: 80,
  },
];

const frameworkComponents = {
  DeleteCellRenderer: DeleteCellRenderer,
};

const defaultColDef = {
  sortable: true,
  filter: true,
  resizable: true,
  draggable: true,
  suppressMenu: true,
};

const Root = styled.div`
  height: 250px;
  border: 1px solid #bdc3c7;
  overflow: hidden;
  background: rgba(208, 208, 208, 0.75);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
`;
const Title = styled.div`
  align-self: flex-start;
  padding: 10px 0 2px 10px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
`;
const GridWrapper = styled.div`
  position: relative;
  flex: 1 1 300px;
`;

const EntitySelectorGrid = (props) => {

  const selectedEntities = useSelector(
    selectSelectedEntities(SelectionState.UNCOMMITTED)
  );
  
  const fetchingEntities = useSelector(selectFetchingEntities);

  return (
    <Root>
      <Title>Selected Entities:</Title>
      <GridWrapper>
        <LoadingMask active={fetchingEntities} />
        <Grid
          rowData={selectedEntities}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          frameworkComponents={frameworkComponents}
          bandedRows={false}
          enableVerticalGridLines={false}
          sideBar={null}
          rowSelection={"multiple"}
        />
      </GridWrapper>
    </Root>
  );
};

export default EntitySelectorGrid;
